import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "胆振東部地震フォトグラメトリー"
const scope = "VR空間設計・制作"
const str1 = "北海道胆振東部地震で発生した土砂崩れのありのままの姿を、北海道在住のでちでち氏が3Dモデル化しVRでの公開を決めたため、これに協力し、最低限のしつらえを追加して1:500スケールで空間化した。"
const str2 = "震災の当事者でない者としてできることは、感情的な物語を生むことでも、祈りでもなく、生データの記録と公開である。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.iburi01.childImageSharp.original.src}
          pageimgw={data.iburi01.childImageSharp.original.width}
          pageimgh={data.iburi01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/iburi01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/iburi02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/iburi03.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  iburi01: file(relativePath: {eq: "iburi01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
